import * as yup from 'yup';

export const collectionSchema = yup.object().shape({
  title: yup
    .string()
    .required('Title is required')
    .max(50, 'Title must be no more than 50 characters long'),
  description: yup
    .string()
    .notRequired()
    .max(10000, 'Description must be no more than 10000 characters long'),
  addedArtworks: yup.array(),
});
